import React, { memo } from 'react';
import PropTypes from 'prop-types';

import InnerHTML from '@/components/Base/InnerHTML';
import Menu from '@/components/Base/Menu';
import StaticContent from '@/components/Base/StaticContent';
import { CONTENT_POSITION_TYPES, CONTENT_TYPES } from '@/constants';

import { Blocks, Wrapper } from './ContentZone.styles';

function ContentZone({ content = null, position }) {
  if (!content?.length) {
    return null;
  }
  const isBottomLinkBlockExist =
    content.find((i) => i.type === CONTENT_TYPES.menu) &&
    position === CONTENT_POSITION_TYPES.contentBottom;

  return (
    <Wrapper>
      {content?.map(
        ({ id, content: blockContent, type, items, caption }, index) => (
          <Blocks
            key={`${id}-${index}`}
            position={position}
            $isRemoveStyles={
              (type === CONTENT_TYPES.menu &&
                position === CONTENT_POSITION_TYPES.contentBottom) ||
              type === CONTENT_TYPES.static
            }
          >
            {type === CONTENT_TYPES.static && <StaticContent />}

            {type === CONTENT_TYPES.html && (
              <InnerHTML key={id} html={blockContent} />
            )}

            {type === CONTENT_TYPES.menu &&
              position !== CONTENT_POSITION_TYPES.contentBottom && (
                <Menu items={items} position={position} caption={caption} />
              )}
          </Blocks>
        )
      )}

      {isBottomLinkBlockExist && (
        <Blocks position={position} $botomLinkBlocks>
          {content?.map(
            ({ items, caption, type }) =>
              type === CONTENT_TYPES.menu &&
              position === CONTENT_POSITION_TYPES.contentBottom && (
                <Menu
                  key={caption}
                  items={items}
                  position={position}
                  caption={caption}
                />
              )
          )}
        </Blocks>
      )}
    </Wrapper>
  );
}

ContentZone.propTypes = {
  content: PropTypes.arrayOf(PropTypes.any),
  position: PropTypes.string.isRequired,
};

export default memo(ContentZone);
